// THE ONE COPY OF THE SUPPORT-WIDGET LOADER — card 6aa8b5f050645cd1c3e765c0.
//
// There used to be two. This logic compiled into the app bundle from
// init_agent_view.coffee, and a hand-written copy sat in the marketing site's
// SiteTheme `javascript` field, mounting the same widget on the homepage. The
// copy was made before the fixes and never caught up: it mounted the iframe
// with no availability check (so a visitor got a stray "App Not Found." box
// pinned over the homepage whenever the chat app was down), it posted the
// session context with target "*", and its message listener accepted open and
// close from any origin.
//
// Two copies of a security-shaped loader is the defect. So there is one file,
// and both callers load THIS: the app bundle imports it through webpack
// (init_agent_view.coffee is now a shim over it) and the marketing page loads
// it with a script tag from /widget/agent-widget-loader.js, which
// manifest.json serves out of this directory.
//
// Plain ES5 on purpose. It has to be readable by webpack's CommonJS interop
// and by a browser with no build step at all, and the two must be the same
// bytes — a build that transformed it for one of them would put the drift
// back.

(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (root) root.elAgentWidget = api;
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var APP_ID = '69b09191aaa5ca4af0450de1';
  var AGENT_ID = '69b1d3e54779ed178422680a';
  var FRAME_ID = 'el-agent-widget-frame';

  // The widget's own conversation record, written by AgentView's saveSession.
  // Named here as well because signing out has to be able to remove it, and
  // the sign-out path is on this side of the frame.
  var STORAGE_KEY = 'elAgentChat.' + AGENT_ID;

  // THE OPENED FRAME MUST FIT THE SCREEN IT IS ON.
  // Card 6aa8b5f050645cd1c3e765be.
  //
  // It was a flat 420x600. The frame is pinned to the bottom RIGHT, so on a
  // 390px phone it started 30px off the left edge of the screen — measured at
  // x=-5, with the email field and the message box both outside the viewport.
  // A parent on a phone could open support chat and then not type in it.
  //
  // A CAP against the viewport is the whole fix: the desktop size is unchanged
  // and a narrow screen gets a frame it can contain. dvh, not vh, so a mobile
  // browser's collapsing toolbar does not push the input row under the chrome.
  //
  // max-width/max-height rather than `width: min(420px, 100vw)`, which says the
  // same thing: the cap is understood by everything that has ever rendered this
  // widget, and it stays observable in a headless DOM, where a `min()` width is
  // silently dropped and a pin would be asserting against the collapsed size.
  var OPEN_WIDTH = '420px';
  var OPEN_HEIGHT = '600px';
  var OPEN_MAX_WIDTH = '100vw';
  var OPEN_MAX_HEIGHT = '100dvh';
  var COLLAPSED = '90px';

  // AND IT MUST NOT SWALLOW THE PAGE'S OWN CONTROLS.
  // Card 6aa8c8c350645cd1c3e766db.
  //
  // At 1440x900 the expanded panel sits on top of the parent dashboard's
  // next-student chevron, and at z-index 999999 it takes its clicks: every
  // attempt landed on the iframe ("intercepts pointer events"). A parent with
  // two children who opened the chat to ask about one of them could not move
  // to the other without closing the chat first.
  //
  // The host page is marked while the chat is expanded and moves its own
  // controls clear (el-feet's Dashboard/dashboard.scss). The loader does not
  // need to know what those controls are, and a page with none is unaffected.
  var OPEN_CLASS = 'el-chat-open';

  function markHost(open) {
    try {
      var list = document.body && document.body.classList;
      if (!list) return;
      if (open) list.add(OPEN_CLASS); else list.remove(OPEN_CLASS);
    } catch (err) {
      // No body yet, or a document that does not carry classList. Nothing to
      // mark, and the chat still opens.
    }
  }

  // AND IT MUST STAY WHERE THE PERSON CAN SEE IT WHILE THEY SCROLL.
  // Card 6aad6d475dcc491e6e883716.
  //
  // `position:fixed;bottom:0` anchors the frame to the LAYOUT viewport. On a
  // phone that is not the rectangle the person is looking at: the visual
  // viewport is shorter while the browser's toolbars are out, and it slides
  // against the layout viewport as they collapse and come back during a
  // scroll. So the chat rides up and down the screen mid-scroll instead of
  // sitting at the bottom of it, and `100dvh` — a unit defined to follow the
  // chrome — resizes the open panel at the same time. Both halves of what the
  // report describes: "the position of the chat window changes", "widget
  // size/location do not move during page scroll".
  //
  // window.visualViewport is the rectangle the person actually sees. The gap
  // between its bottom edge and the layout viewport's is exactly how far the
  // frame is out of place, and a translateY closes it. `transform` is not in
  // the frame's transition list, so this tracks the scroll rather than lagging
  // 0.3s behind it.
  //
  // WHERE THERE IS NO visualViewport the gap is 0 and nothing is written:
  // every desktop browser, and the headless DOM the pins run in, keep exactly
  // today's geometry. The CSS anchor stays `bottom:0` and `100dvh` stays the
  // max-height, so this only ever corrects; it is never the thing holding the
  // widget on the screen.
  var frameOpen = false;

  function visualViewportGap() {
    var vv = window.visualViewport;
    if (!vv) return 0;
    var layout = (document.documentElement && document.documentElement.clientHeight) ||
                 window.innerHeight || 0;
    if (!layout) return 0;
    var gap = layout - (vv.offsetTop + vv.height);
    // NaN, a negative, and a viewport taller than the layout all read the same
    // way: nothing to correct. Never move the frame DOWN, off the screen.
    return gap > 0 ? Math.round(gap) : 0;
  }

  function anchorFrame() {
    var frame = document.getElementById(FRAME_ID);
    if (!frame) return;
    var gap = visualViewportGap();
    frame.style.transform = gap ? 'translateY(-' + gap + 'px)' : '';
    // An open panel is capped by what is visible, not by what dvh reports
    // mid-transition. A collapsed launcher is 90px square and needs no cap.
    var vv = window.visualViewport;
    if (frameOpen) {
      frame.style.maxHeight = vv ? Math.round(vv.height) + 'px' : OPEN_MAX_HEIGHT;
    }
  }

  // Registered at mount and removed at unmount: the widget comes and goes as
  // the family moves between the parent's screens and a child's, and a
  // listener left behind would outlive the frame it was written for.
  function startAnchor() {
    var vv = window.visualViewport;
    if (vv && vv.addEventListener) {
      vv.addEventListener('resize', anchorFrame);
      vv.addEventListener('scroll', anchorFrame);
    }
    window.addEventListener('scroll', anchorFrame);
    anchorFrame();
  }

  function stopAnchor() {
    var vv = window.visualViewport;
    if (vv && vv.removeEventListener) {
      vv.removeEventListener('resize', anchorFrame);
      vv.removeEventListener('scroll', anchorFrame);
    }
    window.removeEventListener('scroll', anchorFrame);
  }

  function openFrame(frame) {
    frame.style.width = OPEN_WIDTH;
    frame.style.height = OPEN_HEIGHT;
    frame.style.maxWidth = OPEN_MAX_WIDTH;
    frame.style.maxHeight = OPEN_MAX_HEIGHT;
    frameOpen = true;
    markHost(true);
    anchorFrame();
  }

  function closeFrame(frame) {
    frame.style.width = COLLAPSED;
    frame.style.height = COLLAPSED;
    frameOpen = false;
    markHost(false);
    anchorFrame();
  }

  // THE CHILD'S SCREENS GET NO SUPPORT LAUNCHER, AND NO SOCKET.
  // Card 6aa9eefa7fc38cab6b35aded.
  //
  // The widget used to be mounted once at app boot and left on the page for
  // the whole session, so it rode along into the game list and into game play
  // — screens a child is using and where a parent's support chat has nothing
  // to offer. It was not merely visible there: the iframe is the schema
  // BaseApp shell, which calls establishSocket at its own boot, so every game
  // page load opened one extra websocket to the instance for a launcher
  // nobody could use. Measured on the elfeet QA visual pool 2026-09-15:
  // 3,121 of 19,446 play records logged that socket failing from inside a
  // game, out of the widget's own bundle.
  //
  // display:none is NOT the fix and never was — hide_agent_widget() has been
  // called from game_layout all along. A hidden iframe is still a loaded
  // iframe and its socket is still open. The owner's requirement is that it
  // must not even connect, and the only thing that satisfies that is not
  // creating the frame, and DESTROYING it if the route changes underneath one
  // that already exists.
  //
  // Matched on the hash because that is what this app navigates by
  // (its own hash router, router/hash_router.coffee). playsubject renders the same
  // GameLayout as play — it IS game play — and playback is the history
  // player, which the owner added to the list.
  var CHILD_ROUTES = /^#?\/(games|play|playsubject|playback)(\/|\?|$)/;

  function routeAllowsWidget() {
    var hash = (window.location && window.location.hash) || '';
    return !CHILD_ROUTES.test(hash);
  }

  function unmount() {
    var frame = document.getElementById(FRAME_ID);
    if (!frame) return;
    var parent = frame.parentNode || document.body;
    if (parent && parent.removeChild) parent.removeChild(frame);
    stopAnchor();
    frameOpen = false;
    // The chat may have been open when the child's screen was entered. The
    // host page moves its own controls for an open chat (OPEN_CLASS); leaving
    // the mark behind would shift a dashboard that no longer has a chat on it.
    markHost(false);
    // Nothing has been told anything yet, so the next frame is not "unchanged".
    lastPosted = null;
  }

  // Origin of the agent-widget iframe. Set when the frame is created so the
  // session token is only ever posted to — and messages only accepted from —
  // that exact origin, never '*'. Defaults to same-origin.
  var frameOrigin = (typeof window !== 'undefined' && window.location) ? window.location.origin : '';

  // AN ACCOUNT WITHOUT A TOKEN IS NOT A SESSION — card 6aa998ff1ff4eb57d5032a13.
  //
  // This reads four fields off the host, and it used to read them
  // independently: the token from loopbackAPI, the account and student from
  // whatever the app still had lying around. After a logout that does not
  // navigate, the app kept its `login` object while the token was already
  // gone, so this reported {access: null, accountId: <the person who just
  // left>} — and the widget, which takes an incoming accountId to mean
  // somebody is signed in, wrote their thread back to storage.
  //
  // Application::onSignOut clears those fields now, which is the real fix.
  // This is the second half of the same sentence, and it belongs here because
  // this function is what CLAIMS a session exists: who the person is, is
  // answered by the credential. No token, nobody signed in — whatever else
  // the host still happens to be holding.
  function currentContext() {
    var app = window.app || {};
    var access = (app.loopbackAPI && app.loopbackAPI.accessTokenId) || null;
    return {
      access: access,
      screen: window.location.hash,
      studentId: access ? (app.activeStudentId || null) : null,
      accountId: access ? ((app.login && app.login.account && app.login.account.id) || null) : null
    };
  }

  // What was last posted, so a change can be recognised. Not a cache: it is
  // only ever compared, never sent.
  var lastPosted = null;

  function sendContextToFrame() {
    var frame = document.getElementById(FRAME_ID);
    if (!frame) return;
    var ctx = currentContext();
    lastPosted = JSON.stringify(ctx);
    ctx.type = 'agent-widget:context';
    frame.contentWindow.postMessage(ctx, frameOrigin);
  }

  // THE CHAT MUST BE TALKING ABOUT THE CHILD ON THE SCREEN.
  // Card 6aa8bc1950645cd1c3e7662c.
  //
  // Context used to be posted on ONE event: the widget telling us it had been
  // opened. So a parent with two children who opened the chat on Wren,
  // switched the dashboard to Oskar and then asked "how is he doing?" got an
  // answer about Wren — the widget still held Wren's studentId and the agent
  // read Wren's dashboard. Measured live 2026-09-14.
  //
  // The widget already REPLACES the context it holds on every message (and
  // resets the thread when the account changes), so the whole fix is on this
  // side: notice the change and say so.
  //
  // Why a watcher rather than a hook on the student switcher: the active
  // student moves from several places (the dashboard switcher, a deep link, a
  // report route, a refresh after enrolment) and the screen moves on every
  // navigation. What matters is not which of them fired but that what the
  // widget holds is stale, so the honest test is to compare the context
  // itself. It is four fields, once a second, next to an open support chat.
  var WATCH_MS = 1000;
  var watchTimer = null;

  function postContextIfChanged() {
    var frame = document.getElementById(FRAME_ID);
    if (!frame) return;
    if (JSON.stringify(currentContext()) === lastPosted) return;
    sendContextToFrame();
  }

  function watchContext() {
    if (watchTimer !== null) return;
    window.addEventListener('hashchange', postContextIfChanged);
    watchTimer = window.setInterval(postContextIfChanged, WATCH_MS);
  }

  // SIGNING OUT TAKES THE SUPPORT CHAT WITH IT — card 6aa95b3fbc2031a10de564f3.
  //
  // The widget clears its own record when the host tells it the session ended,
  // but a real Log Out does not give it the chance: the app navigates away and
  // the frame is destroyed before any context message is posted. The record
  // survived in localStorage, so the next widget to mount in that browser —
  // the guest one on the marketing homepage — loaded the signed-out parent's
  // uuid and asked the server for their transcript. The server refuses an
  // anonymous read of an owned thread, so it was the attempt and not a leak;
  // it is still the previous person's conversation id sitting in a stranger's
  // browser, which is exactly the retention card 6aa888d12a5f6be49b53ae9d set
  // out to end.
  //
  // Called from Application::onSignOut in loopback_api.coffee, which the
  // framework's clearUser() invokes on every logout of every shell.
  function clearSession() {
    try {
      if (window.localStorage) window.localStorage.removeItem(STORAGE_KEY);
    } catch (err) {
      // Private browsing, or storage disabled. There is nothing retained to
      // clear in that case either.
    }
  }

  function initAgentView(serverUrl) {
    serverUrl = serverUrl || '';
    if (serverUrl) {
      try { frameOrigin = new URL(serverUrl).origin; }
      catch (err) { frameOrigin = window.location.origin; }
    } else {
      frameOrigin = window.location.origin;
    }
    var launchUrl = serverUrl + '/api/apps/' + APP_ID + '/launch?mode=bubble&agentId=' + AGENT_ID;

    function mount() {
      if (document.getElementById(FRAME_ID)) return;
      var frame = document.createElement('iframe');
      frame.id = FRAME_ID;
      frame.src = launchUrl;
      frame.style.cssText = 'position:fixed;bottom:0;right:0;width:' + COLLAPSED + ';height:' + COLLAPSED + ';border:none;z-index:999999;transition:width 0.3s ease,height 0.3s ease;';
      frame.setAttribute('title', 'Customer Support Chat');
      document.body.appendChild(frame);
      // Held against the visible viewport from the moment it exists, not from
      // the first scroll: a phone that mounts the widget with its toolbars
      // already out is out of place before anybody touches the screen.
      startAnchor();
      // From here on the widget is told about every change, not only about
      // being opened (card 6aa8bc1950645cd1c3e7662c).
      watchContext();
    }

    // ASK BEFORE MOUNTING. This iframe used to go onto the page
    // unconditionally, so whatever the launch endpoint returned was pinned to
    // the bottom-right corner of EVERY screen at z-index 999999, on top of
    // page content. When the app is not there the endpoint answers 404 with
    // the body "App Not Found." — and that is what the parent saw, a stray box
    // of error text over the dashboard. On elephantmath the row exists but its
    // assets do not load, which renders the same way: an unstyled grey square
    // with a document icon, sitting over the Elephant Age graph on desktop and
    // over the subject list on a phone (card 6a99a0ae2e4684894d656e4a).
    //
    // A support launcher that cannot open a chat has nothing to offer, so the
    // honest thing is to show nothing at all. One HEAD request settles it, and
    // it costs nothing next to the iframe it is gating. A network failure is
    // treated as "not available" for the same reason.
    //
    // ONE probe per session, not one per navigation: the answer is remembered
    // (`available`), because the widget now mounts and unmounts as the person
    // moves between their own screens and a child's, and re-asking on every
    // transition would turn one request into a stream of them. `probing`
    // keeps two fast transitions from racing a second probe onto the wire.
    var available = null;
    var probing = false;

    function probeThenMount() {
      if (probing) return;
      probing = true;
      fetch(launchUrl, {method: 'HEAD', credentials: 'same-origin'})
        .then(function (res) {
          probing = false;
          available = !!res.ok;
          if (available) applyRoute();
          else console.warn('Support chat launcher not available (' + res.status + ') — not mounting.');
        })
        .catch(function (err) {
          probing = false;
          available = false;
          console.warn('Support chat launcher unreachable — not mounting.', err);
        });
    }

    // The single decision: does this screen get the widget, and does what is
    // on the page agree? Called at boot and on every hash navigation, so a
    // child who deep-links straight into a game never mounts one in the first
    // place, and a parent who walks into a game from the dashboard has theirs
    // removed — frame gone, socket closed — and gets it back on the way out.
    function applyRoute() {
      if (!routeAllowsWidget()) { unmount(); return; }
      if (available === false) return;
      if (available === null) { probeThenMount(); return; }
      mount();
    }

    // Registered even while nothing is mounted: this listener is how a
    // suppressed route learns it is no longer suppressed. The context watcher
    // (watchContext) has its own hashchange handler and starts at mount —
    // there is nothing to tell the widget about until there is a widget.
    window.addEventListener('hashchange', applyRoute);
    applyRoute();

    window.addEventListener('message', function (e) {
      // Only trust messages from the widget iframe ITSELF — the frame we
      // created, on the origin we created it at. Card 6aa888d12a5f6be49b53ae9d.
      //
      // The origin check alone was not enough: any other window on that origin
      // — another frame on the page, a popup, anything the page opened —
      // passes it while being a different sender entirely. Checking the source
      // pins it to the one window whose messages mean anything here, and it is
      // the same check the widget makes in the other direction.
      //
      // Resize is all this grants, so the consequence of getting it wrong is
      // small; it is checked anyway because a receiver that does not verify
      // its sender is the pattern, and the widget's own receiver is where the
      // pattern was costly.
      if (e.origin !== frameOrigin) return;
      var frame = document.getElementById(FRAME_ID);
      if (!frame) return;
      if (!e.source || e.source !== frame.contentWindow) return;
      if (e.data && e.data.type === 'agent-widget:open') {
        openFrame(frame);
        sendContextToFrame();
      } else if (e.data && e.data.type === 'agent-widget:close') {
        closeFrame(frame);
      }
    });
  }

  // Mount as soon as there is a body to mount into. The app bundle calls
  // initAgentView itself once its own boot is done; the marketing page's
  // SiteTheme snippet calls this, because on that page there is no bundle.
  function initWhenReady(serverUrl) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAgentView(serverUrl); });
    } else {
      initAgentView(serverUrl);
    }
  }

  return {
    APP_ID: APP_ID,
    AGENT_ID: AGENT_ID,
    STORAGE_KEY: STORAGE_KEY,
    OPEN_WIDTH: OPEN_WIDTH,
    OPEN_HEIGHT: OPEN_HEIGHT,
    OPEN_MAX_WIDTH: OPEN_MAX_WIDTH,
    OPEN_MAX_HEIGHT: OPEN_MAX_HEIGHT,
    OPEN_CLASS: OPEN_CLASS,
    anchorFrame: anchorFrame,
    visualViewportGap: visualViewportGap,
    initAgentView: initAgentView,
    initWhenReady: initWhenReady,
    clearSession: clearSession
  };
});
